{
  "generate_callsheet": "Générer une Callsheet",
  "header": "Header",
  "location": "Location",
  "schedule": "Programme",
  "talent_cast": "Talent - cast",
  "talent_crew": "Talent - crew",
  "notes": "Notes",
  "weather": "Météo",
  "date": "Date",
  "shooting_day": "Shooting day",
  "call_times": "Call times",
  "general": "General",
  "crew_call": "Crew call",
  "lunch": "Lunch",
  "cast_call": "Cast call",
  "extras_call": "Extras call",
  "vip_contact": "VIP contact",
  "name": "Nom",
  "role": "Role",
  "phone": "Téléphone",
  "email": "E-mail",
  "add_location": "Ajouter une location",
  "start": "Début",
  "scene": "Scene",
  "scene_description": "Description",
  "estimated_time": "Durée estimée",
  "add_schedule": "Ajouter un programme",
  "talent": "Talent",
  "pick_up": "Pick up",
  "call": "Call",
  "on_set": "On set",
  "add_cast": "Add cast",
  "note": "Note",
  "field_required": "Ce champs est obligatoir",
  "location_name": "Location",
  "address": "Adresse",
  "city": "Ville"
}
